export default {
  data() {
    return {
      tableColumns: [] //表格列
    };
  },
  methods: {
    buildTableColumns(columns = []) {
      if (columns.length > 0) {
        this.tableColumns = columns;
      } else {
        this.tableColumns = [
          {
            prop: "star",
            label: "精选",
            showColumn: true,
            width: 80,
            align: "center",
            sortable: "custom"
          },

          {
            prop: "name",
            label: "名称",
            minWidth: 180,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "address",
            label: "地址",
            minWidth: 150,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "description",
            label: "描述",
            minWidth: 130,
            showColumn: false,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "designer_name",
            label: "设计师",
            width: 100,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "developer_name",
            label: "开发商",
            width: 100,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "shooting_date",
            label: "拍摄日期",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "types",
            label: "类型",
            minWidth: 200,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },

          {
            prop: "cover_image_url",
            label: "封面图",
            showColumn: true,
            width: 100,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "images",
            label: "图片集合",
            showColumn: true,
            width: 120,
            align: "center",
            sortable: "custom"
          },

          {
            prop: "poster_image_url",
            label: "海报图",
            showColumn: true,
            width: 100,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "poster_slogan",
            label: "海报标语",
            width: 120,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "id",
            label: "ID",
            width: 80,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "disabled",
            label: "状态",
            showColumn: true,
            width: 100,
            align: "center",
            sortable: "custom"
          },

          {
            prop: "createdAt",
            label: "创建时间",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },

          {
            prop: "lastModifiedAt",
            label: "更新时间",
            showColumn: true,
            width: 120,
            align: "center",
            sortable: "custom"
          }
          // {
          //   prop: "controlColumn",
          //   fixed: "right",
          //   align: "center",
          //   showColumn: true,
          //   label: "操作",
          //   width: 180,
          // },
        ];
      }
    }
  }
};
